export default {
  INPROGRESS: 'in-progress',
  SUCCEEDED: 'succeeded',
};



// WEBPACK FOOTER //
// ./src/transport/constants/publish-statuses.js